import moment from 'moment'

export const promotionsLimits = {
    state: {
        limits: null,
        status: 'idle'
    },
    mutations: {
        SET_PROMOTIONS_LIMITS(state, payload) {
            state.limits = payload
        },
        SET_PROMOTIONS_LIMITS_STATUS(state, payload) {
            state.status = payload
        }
    },
    actions: {
        async fetchPromotionsLimits({ commit, getters }, payload) {
            try {
                commit('SET_PROMOTIONS_LIMITS_STATUS', 'loading')

                // get current week dates
                const today = moment()
                const daysUntilLastMonday = (today.day() + 7 - 1) % 7

                const monday = today
                    .clone()
                    .subtract(daysUntilLastMonday, 'days')

                const sunday = monday.clone().add(6, 'days')

                const res = await this.$api.post(
                    'reports/promotion_limit_usage',
                    {
                        paging: {
                            orderDirection: 'ASC',
                            orderBy: null,
                            numberOfPage: 0,
                            numberOfRows: 100
                        },
                        userId: getters.userId,
                        shopIds: getters.getLocationIds,
                        promotionId: +payload.promoId,
                        startDate: monday.format('YYYY-MM-DD'),
                        endDate: sunday.format('YYYY-MM-DD')
                    }
                )
                commit('SET_PROMOTIONS_LIMITS', res.data.data)
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_PROMOTIONS_LIMITS_STATUS', 'idle')
            }
        }
    },
    getters: {
        getPromotionsLimits: state => state.limits
    }
}
